import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BookOpen, Layers, Sliders, Gauge, Upload, Tag, FlaskConical, ListChecks, Star, Settings, Sparkles, Eye } from "lucide-react";

const NAV = [
  { to: "/creator/modules", label: "Course Modules", icon: BookOpen },
  { to: "/creator/levels", label: "Learner Levels", icon: Layers },
  { to: "/creator/difficulty", label: "Difficulty Settings", icon: Sliders },
  { to: "/creator/pacing", label: "Pacing Controls", icon: Gauge },
  { to: "/creator/uploads", label: "Curriculum Uploads", icon: Upload },
  { to: "/creator/words", label: "Word & Phrase Lists", icon: Tag },
  { to: "/creator/examples", label: "Examples Library", icon: FlaskConical },
  { to: "/creator/mcqs", label: "CFU MCQs", icon: ListChecks },
  { to: "/creator/rubrics", label: "Feedback Rubrics", icon: Star },
  { to: "/creator/ai-tutor", label: "AI Tutor Behaviour", icon: Settings },
  { to: "/creator/mashy", label: "Mashy Behaviour", icon: Sparkles },
  { to: "/creator/preview", label: "Preview as Learner", icon: Eye },
];

export default function CreatorSidebar() {
  const loc = useLocation();
  return (
    <aside className="hidden md:flex w-72 shrink-0 flex-col bg-white border-r-2 border-gray-200 min-h-screen p-4 gap-1" data-testid="creator-sidebar">
      <div className="px-3 py-4">
        <div className="font-display text-2xl text-[#1CB0F6]">Mashy</div>
        <div className="text-xs text-gray-500 font-semibold uppercase tracking-widest">Course Creator</div>
      </div>
      {NAV.map((n) => {
        const active = loc.pathname.startsWith(n.to);
        return (
          <Link
            key={n.to}
            to={n.to}
            data-testid={`cc-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-xl font-bold text-sm transition-colors ${
              active ? "bg-[#1CB0F6] text-white" : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            <n.icon strokeWidth={2.5} className="w-5 h-5" />
            <span>{n.label}</span>
          </Link>
        );
      })}
    </aside>
  );
}
